const ciudades = [
    { label: "Amazonas", value: "amazonas" },
    { label: "Antioquía", value: "antioquía" },
    { label: "Arauca", value: "arauca" },
    { label: "Atlántico", value: "atlántico" },
    { label: "Bolívar", value: "bolívar" },
    { label: "Boyacá", value: "boyacá" },
    { label: "Caldas", value: "caldas" },
    { label: "Caquetá", value: "caquetá" },
    { label: "Casanare", value: "casanare" },
    { label: "Cauca", value: "cauca" },
    { label: "Cesar", value: "cesar" },
    { label: "Chocó", value: "chocó" },
    { label: "Córdoba", value: "córdoba" },
    { label: "Cundinamarca", value: "cundinamarca" },
    { label: "Bogotá", value: "bogotá" },
    { label: "Guainia", value: "guainia" },
    { label: "Guaviare", value: "guaviare" },
    { label: "Huila", value: "huila" },
    { label: "Guajira", value: "guajira" },
    { label: "Magdalena", value: "magdalena" },
    { label: "Meta", value: "meta" },
    { label: "Nariño", value: "nariño" },
    { label: "Norte de Santander", value: "norte-de-santander" },
    { label: "Putumayo", value: "putumayo" },
    { label: "Quindío", value: "quindío" },
    { label: "Risaralda", value: "risaralda" },
    { label: "San Andres y Providencia", value: "san-andres-y-providencia" },
    { label: "Santander", value: "santander" },
    { label: "Sucre", value: "sucre" },
    { label: "Tolima", value: "tolima" },
    { label: "Valle del Cauca", value: "valle-del-cauca" },
    { label: "Vaupés", value: "vaupés" },
    { label: "Vichada", value: "vichada" },
]

export default ciudades;